var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-chats',{attrs:{"data":_vm.chatList,"loading":_vm.loading},on:{"search":function($event){return _vm.search($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }